<a
                href="{{ url | async }}"
                target="_blank"
                class="fa-stack">
                <i class="fa fa-circle fa-stack-1x"></i>
                <i class="fab fa-facebook-f fa-stack-1x"></i>
            </a>